import { view as engineView } from '@sail/engine';
import { usesCssSerializer } from './css';
/**
 * Create intrinsic HTML elements supercharged with support for the css prop and engine intents.
 *
 * @see https://sail.stripe.me/apis/view-tag
 */ export const view = usesCssSerializer(engineView);

//# sourceMappingURL=view.js.map